import React from 'react'

const Notify = () => {
  return (
    <div>Notify</div>
  )
}

export default Notify